import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../js/stores/language.js';
import user from '../../js/stores/user.js';
import validator from 'validator';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $f7router = _ref.$f7router,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var calendarDefault;
  var requestMessage = "";
  var executeMessage = "";
  var maxPoints = 50;
  var strongPassConfig = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: true,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
  };
  var updatePassword = function updatePassword(e) {
    var result = validator.isStrongPassword(e.target.value, strongPassConfig);
    var x = result * 100 / maxPoints;
    $f7.progressbar.set('#password-force', x);
    $update();
  };
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var goTab = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      var name;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            document.getElementById("tab-".concat(id, "-button")).click();
            name = Number(id) == 1 ? 'request' : 'execute';
            document.getElementById("user-form-recovery-".concat(name)).reset();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function goTab(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var requestPasswordRecovery = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var formData, result;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            formData = $f7.form.convertToData('#user-form-recovery-request');
            if (checkUserEmail()) {
              _context3.next = 1;
              break;
            }
            return _context3.abrupt("return");
          case 1:
            _context3.next = 2;
            return user.dispatch('requestReset', formData);
          case 2:
            result = _context3.sent;
            if (!(result.status !== undefined && result.status !== 201)) {
              _context3.next = 3;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context3.abrupt("return");
          case 3:
            requestMessage = locale.translate('user.reset.requestPasswordMessage');
            $f7.toast.show({
              text: requestMessage,
              closeTimeout: 4000
            });
            $update();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function requestPasswordRecovery() {
      return _ref4.apply(this, arguments);
    };
  }();
  var executePasswordRecovery = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var formData, result;
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            formData = $f7.form.convertToData('#user-form-recovery-execute');
            if (checkUserEmailv2()) {
              _context4.next = 1;
              break;
            }
            return _context4.abrupt("return");
          case 1:
            if (checkUserResetToken()) {
              _context4.next = 2;
              break;
            }
            return _context4.abrupt("return");
          case 2:
            if (checkUserPassword()) {
              _context4.next = 3;
              break;
            }
            return _context4.abrupt("return");
          case 3:
            if (checkUserPasswordConfirm()) {
              _context4.next = 4;
              break;
            }
            return _context4.abrupt("return");
          case 4:
            _context4.next = 5;
            return user.dispatch('executeReset', formData);
          case 5:
            result = _context4.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context4.next = 6;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context4.abrupt("return");
          case 6:
            executeMessage = locale.translate('user.reset.executePasswordMessage');
            $f7.toast.show({
              text: executeMessage,
              closeTimeout: 4000
            });
            $update();
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function executePasswordRecovery() {
      return _ref5.apply(this, arguments);
    };
  }();
  var checkUserEmail = function checkUserEmail() {
    var formData = $f7.form.convertToData('#user-form-recovery-request');
    if (!validator.isEmail(formData.UserEmail)) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userEmailValidMessage')
      });
      return false;
    }
    return true;
  };
  var checkUserEmailv2 = function checkUserEmailv2() {
    var formData = $f7.form.convertToData('#user-form-recovery-execute');
    if (!validator.isEmail(formData.UserEmail)) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userEmailValidMessage')
      });
      return false;
    }
    return true;
  };
  var checkUserResetToken = function checkUserResetToken() {
    var formData = $f7.form.convertToData('#user-form-recovery-execute');
    if (validator.isEmpty(formData.UserResetToken)) {
      $f7.toast.show({
        text: 'User token can not be empty'
      });
      return false;
    }
    return true;
  };
  var checkUserPassword = function checkUserPassword() {
    var formData = $f7.form.convertToData('#user-form-recovery-execute');
    var result = validator.isStrongPassword(formData.UserPassword, strongPassConfig);
    if (result < 25) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userPasswordValidationsMessage'),
        closeTimeout: 4000
      });
      return false;
    }
    return true;
  };
  var checkUserPasswordConfirm = function checkUserPasswordConfirm() {
    var formData = $f7.form.convertToData('#user-form-recovery-execute');
    if (!validator.equals(formData.UserPassword, formData.UserPasswordConfirm)) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userPasswordMismatchMessage')
      });
      return false;
    }
    return true;
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="user-password-recovery">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('user.reset.titleDialog')}</div>
    </div>
  </div>
  <div class="toolbar toolbar-top tabbar" style="display: none;">
    <div class="toolbar-inner">
      <a id="tab-1-button" href="#tab-1" class="tab-link tab-link-active">Request New Password</a>
      <a id="tab-2-button" href="#tab-2" class="tab-link">Create New Password</a>
    </div>
  </div>
  <div class="tabs center-content">
    <div id="tab-1" class="page-content tab tab-active login-screen-content">
      <div class="block">
        <div class="block-title">${locale.translate('user.reset.requestNewPassword')}</div>
        <form id="user-form-recovery-request" class="list no-hairlines-md">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.newAccount.userEmailLabel')}</div>
                  <div class="item-input-wrap">
                    <input id="user-email" name="UserEmail" type="email" placeholder="${locale.translate('user.newAccount.userEmailPlaceholder')}" autocomplete="off" @blur="${checkUserEmail}"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </form>
        <div class="block block-strong">
          <p>${requestMessage}</p>
        </div>
        <div class="block block-strong">
          <p class="grid grid-cols-3">
            <div><a href="#" class="button button-small button-fill back">${locale.translate('general.close')}</a></div>
            <div></div>
            <div><a href="#" class="button button-small button-fill button-raised color-green" @click="${requestPasswordRecovery}">${locale.translate('user.reset.requestNewPasswordLabel')}</a></div>
          </p>
          <p class="grid grid-cols-3">
            <div></div>
            <div>
              <a class="button button-outline" href="#" @click="${() => goTab(2)}">
                <i class="material-symbols-outlined">key</i> ${locale.translate('user.reset.getKey')}
              </a>
            </div>
            <div></div>
          </p>
        </div>
      </div>
    </div>
    <div id="tab-2" class="page-content tab login-screen-content">
      <div class="block">
        <div class="block-title">${locale.translate('user.reset.generateNewPassword')}</div>
        <form id="user-form-recovery-execute" class="list no-hairlines-md">
          <ul>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.newAccount.userEmailLabel')}</div>
                  <div class="item-input-wrap">
                    <input id="user-email" name="UserEmail" type="email" placeholder="${locale.translate('user.newAccount.userEmailPlaceholder')}" autocomplete="off" @blur="${checkUserEmailv2}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.reset.userResetTokenLabel')}</div>
                  <div class="item-input-wrap">
                    <input id="user-reset-token" name="UserResetToken" type="text" placeholder="${locale.translate('user.reset.userResetTokenPlaceholder')}" autocomplete="off" @blur="${checkUserResetToken}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.newAccount.userPasswordLabel')}</div>
                  <div class="item-input-wrap">
                    <input id="user-password" name="UserPassword" type="password" autocomplete="off" @input="${updatePassword}" @blur="${checkUserPassword}"
                      placeholder="${locale.translate('user.newAccount.userPasswordPlaceholder')}. ${locale.translate('user.newAccount.userPasswordAllowedCharsMessage')}"/>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="block block-strong-ios block-outline-ios">
                <div id="password-force" class="progressbar color-green"></div>
              </div>
            </li>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">${locale.translate('user.newAccount.userPasswordConfirmLabel')}</div>
                  <div class="item-input-wrap">
                    <input id="user-password-confirm" name="UserPasswordConfirm" type="password" placeholder="${locale.translate('user.newAccount.userPasswordConfirmPlaceHolder')}" 
                    autocomplete="off" @blur="${checkUserPasswordConfirm}"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </form>
        <div class="block block-strong">
          <p>${executeMessage}</p>
        </div>
        <div class="block block-strong">
          <p class="grid grid-cols-3">
            <div><a href="#" class="button button-small button-fill back">${locale.translate('general.close')}</a></div>
            <div></div>
            <div><a href="#" class="button button-small button-fill button-raised color-green" @click="${executePasswordRecovery}">${locale.translate('user.reset.changePasswordLabel')}</a></div>
          </p>
          <p class="grid grid-cols-3">
            <div></div>
            <div>
              <a class="button button-outline" href="#" @click="${() => goTab(1)}">
                <i class="icon icon-back"></i> ${locale.translate('general.back')}
              </a>
            </div>
            <div></div>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '6a2bc48b55';
export default framework7Component;